// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"225":"ffc5b5560588b58de331","581":"8748bd1c64bf73a60123","655":"3f2e2a3d3e29af0ed4f4","728":"cd600cd34563f67e776b"}[chunkId] + ".css";
};